import React, { useState } from 'react';
import useFetch from '../../common/useFetch';
import AuthService from '../../domain/AuthService';
import { User } from '../../domain/Models';
var UserContext = React.createContext({});
var UserProvider = function (_a) {
    var children = _a.children;
    var initialUser = window.lotus.user ? new User(window.lotus.user) : null;
    var _b = useState(initialUser), user = _b[0], setUser = _b[1];
    var _c = useState(window.lotus.twoFactorConfirmed), twoFactorConfirmed = _c[0], setTwoFactorConfirmed = _c[1];
    var logout = useFetch(AuthService.logout, {
        onSuccess: function () {
            setUser(null);
            setTwoFactorConfirmed(false);
        }
    });
    var value = {
        user: user,
        setUser: setUser,
        logout: logout,
        twoFactorConfirmed: twoFactorConfirmed,
        setTwoFactorConfirmed: setTwoFactorConfirmed
    };
    return (React.createElement(UserContext.Provider, { value: value }, children));
};
export default UserProvider;
export { UserContext };
